import { Heading, Stack, Image, Text } from '@chakra-ui/react';

interface IUserGroupPlaceholder {
  title: string;
  description?: string;
  src: string;
  alt?: string;
}

export const UserGroupPlaceholder = ({
  title,
  description,
  src,
  alt,
}: IUserGroupPlaceholder) => (
  <Stack pt='40' align='center' spacing='4'>
    <Image boxSize='24' src={src || ''} alt={alt || ''} />
    <Heading size='md'>{title}</Heading>
    <Text variant='subtle'>{description}</Text>
  </Stack>
);
